import { render, staticRenderFns } from "./MasterProductRow.vue?vue&type=template&id=7eb9e904&scoped=true&"
import script from "./MasterProductRow.vue?vue&type=script&lang=js&"
export * from "./MasterProductRow.vue?vue&type=script&lang=js&"
import style0 from "./MasterProductRow.vue?vue&type=style&index=0&id=7eb9e904&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb9e904",
  null
  
)

/* custom blocks */
import block0 from "./MasterProductRow.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VRow})
